export const products = [
  // Industrial Laser Cutter
  {
    id: 'cm1390e',
    title: 'CM1390E',
    subtitle: 'Industrial Laser Cutter',
    description: 'Industrial Elite Series Laser Cutter with larger engraving area',
    fullDescription: 'Best laser cutter for small business, REDSAIL industrial grade \'Elite\' series CM1390E offers a larger engraving area compared to the standard 48"x36" platforms. New available Drive highest precision in same class stepper motor drive system. Upgrade your laser to be 100W-150W of cutting power (includes the higher industry water chiller). Compatible LightBurn offers an All-In-One laser software thats both intuitive and feature rich.',
    price: 'Contact for Quote',
    image: 'https://www.redsaillaser.com/uploads/20220414/59b60dad7c741cdd53ba132cb3bc2a16.jpg',
    images: [
      'https://www.redsaillaser.com/uploads/20220414/59b60dad7c741cdd53ba132cb3bc2a16.jpg'
    ],
    category: 'Industrial Laser Cutter',
    specs: [
      { label: 'Working Area', value: '51" x 35" (1300mm x 900mm)' },
      { label: 'Laser Power', value: '100W-150W' },
      { label: 'Cutting Speed', value: 'Up to 1200mm/s' },
      { label: 'Drive System', value: 'Stepper Motor' }
    ]
  },
  {
    id: 'm900e',
    title: 'M900E',
    subtitle: 'Industrial Laser Cutter',
    description: 'Industrial Elite Series with full closed stronger frame',
    fullDescription: 'REDSAIL industrial grade \'Elite\' series M900E with the full closed stronger frame which brings more stable working. New available Drive highest precision in same class stepper motor drive system. Upgrade your laser to be 100W-150W of cutting power (includes the higher industry water chiller). Compatible LightBurn offers an All-In-One laser software thats both intuitive and feature rich.',
    price: 'Contact for Quote',
    image: 'https://www.redsaillaser.com/uploads/20220414/a3b5ab8a87a5f73976445fc2459bc49d.jpg',
    images: [
      'https://www.redsaillaser.com/uploads/20220414/a3b5ab8a87a5f73976445fc2459bc49d.jpg'
    ],
    category: 'Industrial Laser Cutter',
    specs: [
      { label: 'Working Area', value: '35" x 35" (900mm x 900mm)' },
      { label: 'Laser Power', value: '100W-150W' },
      { label: 'Frame Type', value: 'Full Closed Stronger Frame' },
      { label: 'Drive System', value: 'Stepper Motor' }
    ]
  },

  // Flatbed Laser Cutter
  {
    id: 'cm2435',
    title: 'CM2435',
    subtitle: 'Flatbed Laser Cutter',
    description: 'Professional Flatbed Laser Cutting Machine with 24" x 35" platform',
    fullDescription: 'REDSAIL Professional Flatbed Laser Cutting Machine can cut through more than 20mm thickness materials with High Powered delivers up to 180 watts. Working platform 24" x35" which can reach your all business demand at small space. REDSAIL designed and engineered single head and optional dual heads which allows laser cutting machine to vector cut and engrave non-metal materials with high working efficiency!',
    price: 'Contact for Quote',
    image: 'https://www.redsaillaser.com/uploads/20220824/bfc88b64bd8935b3377113aa92ac0f9b.jpg',
    images: [
      'https://www.redsaillaser.com/uploads/20220824/bfc88b64bd8935b3377113aa92ac0f9b.jpg'
    ],
    category: 'Flatbed Laser Cutter',
    specs: [
      { label: 'Working Area', value: '24" x 35"' },
      { label: 'Laser Power', value: 'Up to 180W' },
      { label: 'Cutting Thickness', value: 'Over 20mm' },
      { label: 'Head Options', value: 'Single/Dual Head' }
    ]
  },
  {
    id: 'cm1625',
    title: 'CM1625',
    subtitle: 'Flatbed Laser Cutter',
    description: 'Flatbed Laser Cutting Machine with multiple platform sizes',
    fullDescription: 'REDSAIL Professional Flatbed Laser Cutting Machine can cut through more than 20mm thickness materials with High Powered delivers up to 180 watts. Working platform 4\'x6\', 4\'x8\' and 5\'x8\'. REDSAIL designed and engineered single head and optional dual heads which allows laser cutting machine to vector cut and engrave non-metal materials with high working efficiency! New available Driving way with less maintenance and longer working life. Upgrade your laser to be higher cutting power (includes the higher industry water chiller). Compatible LightBurn offers an All-In-One laser software thats both intuitive and feature rich.',
    price: 'Contact for Quote',
    image: 'https://www.redsaillaser.com/uploads/20220414/33cc5dfb4fcc9e7517df84c3518070fc.jpg',
    images: [
      'https://www.redsaillaser.com/uploads/20220414/33cc5dfb4fcc9e7517df84c3518070fc.jpg'
    ],
    category: 'Flatbed Laser Cutter',
    specs: [
      { label: 'Working Area', value: '4\'x6\', 4\'x8\', 5\'x8\'' },
      { label: 'Laser Power', value: 'Up to 180W' },
      { label: 'Cutting Thickness', value: 'Over 20mm' },
      { label: 'Head Options', value: 'Single/Dual Head' }
    ]
  },
  {
    id: 'cm1325',
    title: 'CM1325',
    subtitle: 'Flatbed Laser Cutter',
    description: 'Professional Flatbed Laser Cutting Machine with versatile platform',
    fullDescription: '1325 Laser Cutting Machine can cut through more than 20mm thickness materials with High Powered delivers up to 180 watts. Working platform 4\'x6\', 4\'x8\' and 5\'x8\'. REDSAIL designed and engineered single head and optional dual heads which allows laser cutting machine to vector cut and engrave non-metal materials with high working efficiency! New available Driving way with less maintenance and longer working life. Upgrade your laser to be higher cutting power (includes the higher industry water chiller). Compatible LightBurn offers an All-In-One laser software thats both intuitive and feature rich.',
    price: 'Contact for Quote',
    image: 'https://www.redsaillaser.com/uploads/20220415/4d866b1a19ed78d82d59be7a87826e3c.jpg',
    images: [
      'https://www.redsaillaser.com/uploads/20220415/4d866b1a19ed78d82d59be7a87826e3c.jpg'
    ],
    category: 'Flatbed Laser Cutter',
    specs: [
      { label: 'Working Area', value: '4\'x6\', 4\'x8\', 5\'x8\'' },
      { label: 'Laser Power', value: 'Up to 180W' },
      { label: 'Cutting Thickness', value: 'Over 20mm' },
      { label: 'Head Options', value: 'Single/Dual Head' }
    ]
  },
  {
    id: 'cm1318',
    title: 'CM1318',
    subtitle: 'Flatbed Laser Cutter',
    description: 'Professional Flatbed Laser Cutting Machine with large working area',
    fullDescription: 'REDSAIL Professional Flatbed Laser Cutting Machine can cut through more than 20mm thickness materials with High Powered delivers up to 180 watts. Working platform 4\'x6\', 4\'x8\' and 5\'x8\'. REDSAIL designed and engineered single head and optional dual heads which allows laser cutting machine to vector cut and engrave non-metal materials with high working efficiency! New available Driving way with less maintenance and longer working life. Upgrade your laser to be higher cutting power (includes the higher industry water chiller). Compatible LightBurn offers an All-In-One laser software thats both intuitive and feature rich.',
    price: 'Contact for Quote',
    image: 'https://www.redsaillaser.com/uploads/20220415/9d4d4ac14558343190a753659bf399cf.jpg',
    images: [
      'https://www.redsaillaser.com/uploads/20220415/9d4d4ac14558343190a753659bf399cf.jpg'
    ],
    category: 'Flatbed Laser Cutter',
    specs: [
      { label: 'Working Area', value: '4\'x6\', 4\'x8\', 5\'x8\'' },
      { label: 'Laser Power', value: 'Up to 180W' },
      { label: 'Cutting Thickness', value: 'Over 20mm' },
      { label: 'Head Options', value: 'Single/Dual Head' }
    ]
  },

  // High Power Laser Cutter
  {
    id: 'cm1325h',
    title: 'CM1325H',
    subtitle: 'High Power Laser Cutter',
    description: 'High Power Flatbed Laser Cutting Machine up to 680W',
    fullDescription: 'REDSAIL High Powered Flatbed Laser Cutting Machine delivers up to 680 watts. With a choice between 300W or 480W or 680W power the non-metal laser cutting machine provides high speed, high power cutting. The 300W allows you to cut up to 30mm acrylic and mdf/ply in one pass, you\'ll also be able to cut standard thinner materials (e.g. 3mm acrylic) at up to twice the speed of a standard 150W machine, reducing production time by up to 50%!',
    price: 'Contact for Quote',
    image: 'https://www.redsaillaser.com/uploads/20220415/4d866b1a19ed78d82d59be7a87826e3c.jpg',
    images: [
      'https://www.redsaillaser.com/uploads/20220415/4d866b1a19ed78d82d59be7a87826e3c.jpg'
    ],
    category: 'High Power Laser Cutter',
    specs: [
      { label: 'Working Area', value: '4\'x8\' (1300mm x 2500mm)' },
      { label: 'Laser Power', value: '300W / 480W / 680W' },
      { label: 'Cutting Thickness', value: 'Up to 30mm acrylic' },
      { label: 'Speed Advantage', value: '2x faster than 150W' }
    ]
  },

  // Economical Laser Engraver
  {
    id: 'x1080d',
    title: 'X1080D',
    subtitle: 'Economical Laser Engraver',
    description: 'Clover Series Laser Engraver and Cutter with professional grade',
    fullDescription: 'If you\'re looking for a professional grade smart laser engraving and cutting machine to inspire your business or DIY projects, then REDSAIL Cyclone Series Laser Engraving and Cutting Machine may be the best laser machine on the market today. The stand can be divided into two pieces for going through the narrow door. Get 1200mm/s more speed and 100W more CO2 power vs. competing hobby lasers.',
    price: 'Contact for Quote',
    image: 'https://www.redsaillaser.com/uploads/20220824/e47c632dde4d025144431c51373dda39.jpg',
    images: [
      'https://www.redsaillaser.com/uploads/20220824/e47c632dde4d025144431c51373dda39.jpg'
    ],
    category: 'Economical Laser Engraver',
    specs: [
      { label: 'Working Area', value: '42" x 31" (1080mm x 800mm)' },
      { label: 'Laser Power', value: '100W' },
      { label: 'Cutting Speed', value: 'Up to 1200mm/s' },
      { label: 'Special Feature', value: 'Divisible Stand' }
    ]
  },
  {
    id: 'm6090e',
    title: 'M6090E',
    subtitle: 'Economical Laser Engraver',
    description: 'Professional Cyclone Series with 24"x35" engraving area',
    fullDescription: 'REDSAIL offers a popular 24"x35" engraving and cutting area with 60W or 105W CO2 laser tube. Fastest in Class drive system includes REDSAIL Patent Driving Design. REDSAIL Cyclone Series Laser Engraving and Cutting Machine may be the better choice on laser machine market today. Get 1200mm/s more speed and 100W more CO2 power.',
    price: 'Contact for Quote',
    image: 'https://www.redsaillaser.com/uploads/20220415/44baf9d3f38516fad4d6c3c286b03578.jpg',
    images: [
      'https://www.redsaillaser.com/uploads/20220415/44baf9d3f38516fad4d6c3c286b03578.jpg'
    ],
    category: 'Economical Laser Engraver',
    specs: [
      { label: 'Working Area', value: '24" x 35" (600mm x 900mm)' },
      { label: 'Laser Power', value: '60W / 105W' },
      { label: 'Cutting Speed', value: 'Up to 1200mm/s' },
      { label: 'Drive System', value: 'Patent Driving Design' }
    ]
  },

  // Desktop Laser Engraver
  {
    id: 'x700d',
    title: 'X700D',
    subtitle: 'Desktop Laser Engraver',
    description: 'Clover Series desktop laser for small business and DIY',
    fullDescription: 'If you\'re looking for a professional grade desktop laser engraving or cutting machine to inspire your small business or DIY projects, then REDSAIL Cyclone Series Laser Engraving and Cutting Machine may be the best laser machine under $2K on the market today. Get 1200mm/s more speed and 100W more CO2 power vs. competing hobby lasers.',
    price: 'Contact for Quote',
    image: 'https://www.redsaillaser.com/uploads/20220415/e7fe001017958d3be8f35c2f5207cccf.jpg',
    images: [
      'https://www.redsaillaser.com/uploads/20220415/e7fe001017958d3be8f35c2f5207cccf.jpg'
    ],
    category: 'Desktop Laser Engraver',
    specs: [
      { label: 'Working Area', value: '27" x 19" (700mm x 500mm)' },
      { label: 'Laser Power', value: '100W' },
      { label: 'Cutting Speed', value: 'Up to 1200mm/s' },
      { label: 'Price Range', value: 'Under $2K' }
    ]
  },
  {
    id: 'm4060',
    title: 'M4060',
    subtitle: 'Desktop Laser Engraver',
    description: 'Economical Breeze Series for small business and DIY',
    fullDescription: 'If you\'re looking for a economical grade desktop laser engraving or cutting machine to inspire your small business or DIY projects, then REDSAIL Breeze Series 4060Laser Engraver and Cutter may be the best laser machine under $1K on the market today. Get 1200mm/s more speed and more CO2 power vs. competing hobby lasers.',
    price: 'Contact for Quote',
    image: 'https://www.redsaillaser.com/uploads/20220715/ee4de792cd05aa9d81b007a1b5d386f3.jpg',
    images: [
      'https://www.redsaillaser.com/uploads/20220715/ee4de792cd05aa9d81b007a1b5d386f3.jpg'
    ],
    category: 'Desktop Laser Engraver',
    specs: [
      { label: 'Working Area', value: '15" x 23" (400mm x 600mm)' },
      { label: 'Laser Power', value: '40W / 50W' },
      { label: 'Cutting Speed', value: 'Up to 1200mm/s' },
      { label: 'Price Range', value: 'Under $1K' }
    ]
  },
  {
    id: 'm4060e',
    title: 'M4060E',
    subtitle: 'Desktop Laser Engraver',
    description: 'Professional Cyclone Series 50W/60W desktop laser',
    fullDescription: 'If you\'re looking for a professional grade desktop laser engraving or cutting machine to inspire your small business or DIY projects, then REDSAIL Cyclone Series Laser Engraving and Cutting Machine may be the best laser machine under $2K on the market today. Get 1200mm/s more speed and 100W more CO2 power vs. competing hobby lasers.',
    price: 'Contact for Quote',
    image: 'https://www.redsaillaser.com/uploads/20220415/03e88eb2e035ab12bc6daa64be2105e8.jpg',
    images: [
      'https://www.redsaillaser.com/uploads/20220415/03e88eb2e035ab12bc6daa64be2105e8.jpg'
    ],
    category: 'Desktop Laser Engraver',
    specs: [
      { label: 'Working Area', value: '15" x 23" (400mm x 600mm)' },
      { label: 'Laser Power', value: '50W / 60W' },
      { label: 'Cutting Speed', value: 'Up to 1200mm/s' },
      { label: 'Price Range', value: 'Under $2K' }
    ]
  },
  {
    id: 'm3050',
    title: 'M3050',
    subtitle: 'Desktop Laser Engraver',
    description: 'Economical Breeze Series 40W compact laser',
    fullDescription: 'If you\'re looking for a economical grade desktop laser engraving or cutting machine to inspire your small business or DIY projects, then REDSAIL Breeze Series Laser Engraver and Cutter may be the best laser machine under $1K on the market today. Get 1200mm/s more speed and more CO2 power vs. competing hobby lasers.',
    price: 'Contact for Quote',
    image: 'https://www.redsaillaser.com/uploads/20220415/57c211879970ecad8475aa9548be78b3.jpg',
    images: [
      'https://www.redsaillaser.com/uploads/20220415/57c211879970ecad8475aa9548be78b3.jpg'
    ],
    category: 'Desktop Laser Engraver',
    specs: [
      { label: 'Working Area', value: '11" x 19" (300mm x 500mm)' },
      { label: 'Laser Power', value: '40W' },
      { label: 'Cutting Speed', value: 'Up to 1200mm/s' },
      { label: 'Price Range', value: 'Under $1K' }
    ]
  }
];

export const allProducts = products;
